import { motion } from 'framer-motion';
import Breadcrumbs from '../components/Breadcrumbs';
import { Activity, FolderKanban, Users, FileText, Calendar, Clock } from 'lucide-react';

const mockActivity = [
  { id: 1, action: 'Created project', target: 'Echoes of Mumbai', type: 'project', time: '2 hours ago', icon: FolderKanban },
  { id: 2, action: 'Added team member', target: 'Priya Sharma', type: 'team', time: '5 hours ago', icon: Users },
  { id: 3, action: 'Uploaded file', target: 'Script_v3_final.pdf', type: 'file', time: '1 day ago', icon: FileText },
  { id: 4, action: 'Updated deadline', target: 'Monsoon Noir', type: 'project', time: '1 day ago', icon: Calendar },
  { id: 5, action: 'Created project', target: 'Untitled', type: 'project', time: '2 days ago', icon: FolderKanban },
  { id: 6, action: 'Invited collaborator', target: 'Arjun Mehta', type: 'team', time: '3 days ago', icon: Users },
  { id: 7, action: 'Signed contract', target: 'Production Agreement #4', type: 'contract', time: '4 days ago', icon: FileText },
  { id: 8, action: 'Updated budget', target: 'The Last Frame', type: 'project', time: '5 days ago', icon: FolderKanban },
];

export default function ActivityPage() {
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
      <Breadcrumbs />
      <div className="flex items-center gap-3 mb-8">
        <Activity className="w-5 h-5 text-foreground" strokeWidth={1.5} />
        <h1 className="text-2xl font-semibold tracking-tight font-heading">Activity</h1>
      </div>

      <div className="space-y-1">
        {mockActivity.map((a) => (
          <div
            key={a.id}
            className="flex items-center gap-4 px-4 py-3 rounded-lg hover:bg-secondary/60 transition-colors group"
            data-testid={`activity-${a.id}`}
          >
            <div className="w-8 h-8 rounded-lg bg-secondary flex items-center justify-center flex-shrink-0">
              <a.icon className="w-4 h-4 text-muted-foreground" strokeWidth={1.5} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm">
                <span className="text-muted-foreground">{a.action}</span>
                <span className="font-medium text-foreground ml-1">{a.target}</span>
              </p>
            </div>
            <div className="flex items-center gap-1.5 text-[11px] text-muted-foreground/60 flex-shrink-0">
              <Clock className="w-3 h-3" strokeWidth={1.5} />
              {a.time}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
